import axios, { AxiosError } from "axios";
import router from "./router";
import globalConfig from "./config";
import store from "@/store";
import { computed } from "vue";
import helpers from "@/helpers";

const auth_token = computed(() => store.state.auth_token);
/**
 * Request Interceptor
 */
axios.interceptors.request.use(function (config: any) {
  const token = `Bearer ${auth_token.value}`;
  config.headers.Authorization = token;
  config.baseURL = globalConfig.baseURL;
  return config;
});

/**
 * Response Interceptor
 */
axios.interceptors.response.use(
  (response) => {
    if (response.data.mensagem) {
      helpers.mensagemSucesso(response.data.mensagem);
    }
    return response;
  },
  (error) => {
    const axiosError = error as AxiosError;
    if (error.response.status == 401) {
      store.dispatch("logout");
      router.push("/login");
    }
    if (
      error.response.status == 409 &&
      error.response.data.error == "Optimistic locking error"
    ) {
      alert("Conflito! Outra pessoa já alterou esse registro antes de você.");
      document.location.reload();
    } else if (error.response.status == 422) {
      let errorMsg = "";

      if (error.response.data.errors && Object.keys(error.response.data.errors).length > 0) {
        errorMsg = Object.keys(error.response.data.errors)
          .map((v: any) => error.response.data.errors[v])
          .join("\n");
      }

      if (errorMsg == "[object Object]") {
        errorMsg =
          error.response.data.errors
            .map((vo: any) =>
              Object.values(vo)
                .map((v: any) => `${v}`)
                .join("\n")
            )
            .join("\n") ?? "Erro 422";
      }

      if (typeof error.response.data?.error == "string") {
        errorMsg = error.response.data?.error;
      }

      console.log("errors from validation", error.response.data, errorMsg);
      helpers.mensagemErro(errorMsg);
    } else if (error.response.status == 500) {
      console.log("erro 500", error.response);
      if (error.response?.data?.message) {
        helpers.mensagemErro(error.response?.data?.message);
        return;
      }
      helpers.mensagemErro(
        error.response.data?.errors
          ? (Object.values(error.response.data?.errors || {})[0] as any)[0]
          : "Erro 500"
      );
    } else {
      helpers.mensagemErro(
        error.response.data?.errors
          ? (Object.values(error.response.data?.errors || {})[0] as any)[0]
          : "Erro desconhecido"
      );
    }
    return Promise.reject(axiosError);
  }
);

export default axios;
